import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { AdminLayoutProvider } from './AdminLayoutContext';

/**
 * Admin Layout
 * Used for internal users (administrators, staff)
 * Includes sidebar navigation and header with user menu
 */
export function AdminLayout() {
  return (
    <AdminLayoutProvider>
      <div className="flex min-h-screen w-full overflow-x-hidden">
        <Sidebar />
        <div className="flex min-w-0 flex-1 flex-col lg:ml-64">
          <Header />
          <main className="flex-1 overflow-x-auto p-4 lg:p-6">
            <Outlet />
          </main>
        </div>
      </div>
    </AdminLayoutProvider>
  );
}
